import React from "react";
import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { StyledMainBox } from "../../components/commonComponents/StyledComponents/styled";
import AccessControl from "../../components/commonComponents/Hoc/AccessControl";
import { checkUserDetailsFromCookie } from "../../api_calls/userManagement";
import { resetCampaignsClipsPictureReduxState } from "../../api_calls/utils";
import { useDispatch } from "react-redux";
import { resetBrandReportView } from "../../api_calls/utils";
import Dashboard from "../../components/commonComponents/Embeddable/Dashboard";
import { deleteItems } from "../../Store/actions";

const TailoredFerreroDashboard = () => {
  const [userInfo, setUserInfo] = React.useState({});
  const dispatchAction = useDispatch();
  const EMBEDDABLE_DASHBOARD_ID = process.env.REACT_APP_ENV_NAME === 'demo'
    ? '0573d365-fde2-4d52-bfb2-5c52fa380128'
    : '5ae53cf6-2609-42fe-ac09-7de5cbb705e0';

  React.useEffect(() => {
    resetBrandReportView();
    resetCampaignsClipsPictureReduxState();
    const checkUserDetails = checkUserDetailsFromCookie();
    let userDetailObj = {};
    if (checkUserDetails.success === true) {
      userDetailObj = checkUserDetails.user_detail;
    }
    setUserInfo(userDetailObj);

    // Resetting store dates when the component unmounts
    return () => {
      dispatchAction(deleteItems(["store_dates"]));
    };
  }, []);

  return typeof userInfo.root_company_id !== "undefined" ? (
    <StyledMainBox component="main">
      {/* -------- embeddable dashboard -------- */}
      <Grid container spacing={2}>
        {typeof userInfo.root_company_id !== "undefined" && (
          <Dashboard
            embedDashboardId={EMBEDDABLE_DASHBOARD_ID}
            variables={{}}
            filterConfig={{
              "number_root": userInfo.root_company_id.toString(),
            }} />
        )}
      </Grid>
    </StyledMainBox>
  ) : (
    <></>
  );
};

export default AccessControl(TailoredFerreroDashboard, ["overview_can_view"], [], ["customDashboard"]);
